export default({
  namespaced: true,
  state: {
    loading: true,
    language: process.env.DEFAULT_LANGUAGE,
    menu: [],
    unsaved: false,
    endpoints: {},
    cartNum: 0,
    languages: {
      hu: {},
      en: {}
    },
    orderData: {},
    txtContent: {}
  },
  mutations: {
    change (state, payload) {
      // mutate state
      state.loading = payload
    },
    changeLanguage (state, payload) {
      state.language = payload
      localStorage.setItem('language', payload)
    },
    changeUnsaved (state, payload) {
      state.unsaved = payload
    },
    setMenu (state, payload) {
      state.menu = payload
      localStorage.setItem('menu', JSON.stringify(payload))
    },
    setLanguage (state, payload) {
      state.languages[payload.lang] = payload.payload
    },
    setEndpoints (state, payload) {
      state.endpoints = payload
    },
    setCartNum (state, payload) {
      state.cartNum = payload
    },
    setOrderData (state, payload) {
      state.orderData = payload
    },
    setTxtContent (state, payload) {
      state.txtContent = payload
    }
  },
  getters: {
    getLoading: state => {
      return state.loading
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/modules/loading.js